import { createStore } from "vuex";

export default createStore({
  state: {
    isInit: false,
    folders: [],
    index: null,
    selectFolder: [],
    activeFolder: null,
    selectNav: [],
    isNewBox: false,
    auth: false,
    isMobile: false,
    isDesctop: false,
    height: 0,
    mailboxSetting: [],
    mailbox: [],
    settings: {
      Gmail: {
        clientId:
          // "488540331524-9r36eghvve91a2ogfbqv00shm07q30hd.apps.googleusercontent.com",
          "228843943663-o3ini1rkfgotvpenkaa4qv0qakv5a6pp.apps.googleusercontent.com",
        //"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",
        client_secret: "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",
        redirectUri: "https://email.rcgit.ru/auth",
        accessToken: "",
        host: "imap.gmail.com",
        hostSend: "smtp.gmail.com",
        portSend: 25,
        smtp: {
          address: "smtp.gmail.com",
          port: "587",
        },
        imap: {
          address: "imap.gmail.com",
          port: "993",
        },
      },
      Mailru: {
        clientId: "019ac05b4a15767192cebd907f7e1ce6",
        client_secret: "019ac05b4a15767dae48fd3008f27029",
        redirectUri: "https://email.rcgit.ru/auth/mailru/", //"https://spa-bitrix.ru/marketPlace_mail-app", //"http://localhost:8080",
        accessToken: "",
        host: "imap.mail.ru",
        hostSend: "smtp.mail.ru",
        portSend: 25,
        smtp: {
          address: "smtp.mail.ru",
          port: "587",
        },
        imap: {
          address: "imap.mail.ru",
          port: "993",
        },
      },
      Yandex: {
        clientId: "ffa8854fd062464f82bb943963e3eb15", //"5878a0c0eccd4253b31fbd776a56f093", //"ffa8854fd062464f82bb943963e3eb15",
        //"7fbb7e244f5349c49ecb7f5dd4fb1fda",
        client_secret: "7fbb7e244f5349c49ecb7f5dd4fb1fda", //
        redirectUri: "https://email.rcgit.ru/auth/yandex/", //"https://email.rcgit.ru/yandex/", //"https://spa-bitrix.ru/marketPlace_mail-app", //"http://localhost:8080",
        accessToken: "",
        host: "imap.yandex.com",
        hostSend: "smtp.yandex.com",
        portSend: 25,
        smtp: {
          address: "smtp.yandex.ru",
          port: "587",
        },
        imap: {
          address: "imap.yandex.ru",
          port: "993",
        },
      },
      Rambler: {
        smtp: {
          address: "smtp.rambler.ru",
          port: "587",
        },
        imap: {
          address: "imap.rambler.ru",
          port: "993",
        },
      },
      Yahoo: {
        smtp: {
          address: "smtp.mail.yahoo.com",
          port: "587",
        },
        imap: {
          address: "imap.mail.yahoo.com",
          port: "993",
        },
      },
    },
  },
  getters: {},
  mutations: {
    deleteBox(state, index) {
      state.mailbox = state.mailbox.filter((_, i) => i !== index);
    },
    deleteMailboxSetting(state, index) {
      state.mailboxSetting = state.mailboxSetting.filter((_, i) => i !== index);
    },
    mailboxSettingAdd(state, res) {
      state.mailboxSetting.push(res);
    },
    mailboxSettingStart(state, res) {
      state.mailboxSetting = res;
    },
    mailboxAdd(state, res) {
      state.mailbox.push(res);
    },
    mailboxAddStart(state, res) {
      state.mailbox = res;
    },
    setAuth(state, res) {
      state.auth = res;
      state.isNewBox = false;
    },
    setNewBox(state, res) {
      state.isNewBox = res;
    },
    setHeight(state, res) {
      state.height = res;
    },
    setMobileStatus(state, res) {
      state.isMobile = res;
    },
    setDesctopStatus(state, res) {
      state.isDesctop = res;
    },
    setAccesTokenYA(state, res) {
      state.settings.Yandex.accessToken = res;
    },
    setIndex(state, res) {
      state.index = res;
    },
    setActiveFolder(state, res) {
      state.activeFolder = res;
    },
    setSelectNav(state, res) {
      state.selectNav = res;
    },
    setFolders(state, res) {
      state.folders = res;
    },
    setSelectFolder(state, res) {
      state.selectFolder = res;
    },
  },
  actions: {},
  modules: {},
});
